import { useSyncExternalStore } from "react";

const query = "(prefers-reduced-motion: reduce)";
const subscribe = (notify) => {
  const preference = window.matchMedia(query);
  preference.addEventListener("change", notify);
  return () => preference.removeEventListener("change", notify);
};
const getSnapshot = () => window.matchMedia(query).matches;

/** React to preference changes while the page is open, as well as on first load. */
export default function useMotionPreference() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
